module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=HR - Croatia.8be6d037.svg";